<template lang="html">
  <div class="sidebar" v-bind:class="{ collapsed: !showControls }">
    <div class="logo">БутСервис</div>
    <transition name="fade">
      <nav v-if="showControls">
        <div>
          <router-link :to="{ name: 'all-clients' }">
            <i class="icon-stopwatch"></i> Клиенты
          </router-link>
        </div>
        <div>
          <router-link :to="{ name: 'transactions' }">
            <i class="icon-customers"></i> Транзакции
          </router-link>
        </div>
        <div>
          <router-link :to="{ name: 'claims' }">
            <i class="icon-customers"></i> Заявки
          </router-link>
        </div>
        <div>
          <router-link :to="{ name: 'settings' }">
            <i class="icon-settings"></i> Настройки
          </router-link>
        </div>
        <div v-if="showAdditional">
          <router-link :to="{ name: 'styleguide' }">
            <i class="icon-settings"></i> Styleguide
          </router-link>
        </div>
      </nav>
    </transition>
    <transition name="fade">
      <div v-if="showControls" class="account">
        <div class="row">
          <div class="col-md-7">
            <span>{{ user.username }}</span><br>
            <a href="#" @click="logout()">Выйти</a>
          </div>
          <div class="col-md-5 text-right">
            <img src="../assets/img/ava2.png" alt="" class="avatar">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import auth from '../auth'
import { getCurrentUser } from '@/services/user.service'

export default {
  name: 'sidebar',
  props: {
    showControls: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      user: {
        id: null,
        username: ''
      },

      showAdditional: false
    }
  },
  watch: {
    showControls: function (val) {
      if (val) {
        this.getCurrentUser().then((response) => {
          this.user = response.data
        })
      }
    }
  },
  mounted () {
    this.getCurrentUser().then((response) => {
      this.user = response.data
    })
  },
  methods: {
    getCurrentUser: getCurrentUser,
    logout () {
      auth.logout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?ad324638